import { LinkTabs } from '@plato/ui-legacy/components/ui/link-tabs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export const CustomerDetailPathOverrideEnum = {
    ACTIVITIES: 'ACTIVITIES',
    INSIGHTS: 'INSIGHTS',
    INFO: 'INFO',
} as const;

export type CustomerDetailPathOverrideEnum =
    (typeof CustomerDetailPathOverrideEnum)[keyof typeof CustomerDetailPathOverrideEnum];

type Props = {
    pathOverride?: CustomerDetailPathOverrideEnum;
    customerId: string;
};

export function CustomerDetailNavigation({ pathOverride, customerId }: Props) {
    const location = useLocation();
    const { t } = useTranslation();

    const tabs = useMemo(() => {
        return [
            {
                name: t('navigation_tab__activities', { ns: 'customer-detail' }),
                href: `/customers/${encodeURIComponent(customerId)}`,
                current: false,
                override: CustomerDetailPathOverrideEnum.ACTIVITIES,
            },
            {
                name: t('navigation_tab__analysis', { ns: 'customer-detail' }),
                href: `/customers/${encodeURIComponent(customerId)}/insights`,
                current: false,
                override: CustomerDetailPathOverrideEnum.INSIGHTS,
            },
            {
                name: t('navigation_tab__info', { ns: 'customer-detail' }),
                href: `/customers/${encodeURIComponent(customerId)}/info`,
                current: false,
                override: CustomerDetailPathOverrideEnum.INFO,
            },
        ];
    }, [customerId, t]);

    const tabWithCurrent = useMemo(() => {
        if (pathOverride) {
            return tabs.map((tab) => {
                return { ...tab, current: tab.override === pathOverride };
            });
        }

        const asPath = location.pathname + location.search + location.hash;
        return tabs.map((tab) => {
            return { ...tab, current: asPath === tab.href };
        });
    }, [location.pathname, location.search, location.hash, tabs, pathOverride]);

    return (
        <div className="flex w-full">
            <LinkTabs tabs={tabWithCurrent} />
        </div>
    );
}
